export const MOBILE = 600
export const TABLET = 800
export const DESKTOP = 1000
export const LARGEDESKTOP = 1200



// WEBPACK FOOTER //
// ./src/constants/responsive.js